import React from "react";

interface StepButtonProps {
  text: string;
  completedText: string;
  completed: boolean;
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
}

const StepButton: React.FC<StepButtonProps> = ({
  text,
  completedText,
  completed,
  onClick,
  loading,
  disabled,
}) => {
  return (
    <div
      className={`flex justify-center items-center w-44 h-12 text-semibold text-lg rounded-md ${
        disabled || loading ? "cursor-not-allowed" : ""
      } ${
        completed
          ? "bg-transparent border border-acala-blue-400 text accent-acala-blue-500 text-acala-blue-500 "
          : "bg-acala-blue-500 text-white cursor-pointer"
      }`}
      onClick={() => {
        if (loading || disabled) {
          return;
        }

        onClick();
      }}
    >
      {completed ? completedText : loading ? <img className="animate-loading-spin" src="/Loading.svg" alt="loading" /> : text}
    </div>
  );
};

export default StepButton;
